// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1cTHq","large":"styles_large__1WFnY"};